import { createBaseLineActor } from "./lineActor.js";
import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";

export function createWaterPrefab(k, position, index) {
    const water = createBaseLineActor(k, {
        sprite: "bushe1",
        position,
        index,
        isDuck: false,
        z: 10,
        tags: [ACTOR_TAGS.LINE_WATER],
        extraComponents: [
            k.scale(0.8),
            k.animate()
        ]
    });

    water.slide = async (targetX, duration) => {
        water.play("jump");
        await k.tween(
            water.pos,
            k.vec2(targetX, water.pos.y),
            duration,
            (v) => water.pos = v,
            k.easings.linear
        );
        water.play("idle");
    };

    water.jumpTo = async (targetPos, duration = 0.6) => {
        if (water.isAnimating) return;
        water.isAnimating = true;

        const fromPos = water.pos.clone();
        const arcHeight = 120;
        const midY = Math.min(fromPos.y, targetPos.y) - arcHeight;

        k.tween(fromPos.x, targetPos.x, duration, (v) => {
            water.pos = k.vec2(v, water.pos.y);
        }, k.easings.linear);

        await k.tween(fromPos.y, midY, duration / 2, (v) => {
            water.pos = k.vec2(water.pos.x, v);
        }, k.easings.easeOutQuad);

        await k.tween(midY, targetPos.y, duration / 2, (v) => {
            water.pos = k.vec2(water.pos.x, v);
        }, k.easings.easeInQuad);

        water.isAnimating = false;
    };

    water.hit = async () => {
        water.play("jump", {loop: false});
        await water.jump();
        k.play("bush_touch", {volume: 0.5, speed: 1.8});
    };

    water.poke = async () => {
        water.play("jump", {loop: false});
        k.play("bush_touch", { volume: 0.3, speed: 1.7 });
        await water.jump(0.2, 20);
    }

    water.jump = async (duration = 0.5, jumpHeight = 40) => {
        if (water.isAnimating) return;
        water.isAnimating = true;

        const startY = water.pos.y;
        await k.tween(0, Math.PI, duration, (t) => {
            const currentOffset = Math.sin(t) * jumpHeight;
            water.pos = k.vec2(water.pos.x, startY - currentOffset);
        }, k.easings.linear).onEnd(() => {
            water.pos = k.vec2(water.pos.x, startY);
            water.isAnimating = false;
        });
    };

    return water;
}
